import { render } from "./modalPlusTimeExpirationComponent.vue?vue&type=template&id=add5bc0c"
import script from "./modalPlusTimeExpirationComponent.vue?vue&type=script&lang=js"
export * from "./modalPlusTimeExpirationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__